import React, { useState, useEffect, useContext } from 'react';
import '../../../App.scss';
import 'antd/dist/antd.css';
import { useParams } from 'react-router-dom';
import { PageHeader, Space, Tag, Card, Button, Alert, message } from 'antd';

import StrikePayoutModel from '../../../models/StrikePayoutModel';
import CenteredSpinner from '../../../components/CenteredSpinner';
import PayoutProgressListView from '../../../components/client/PayoutProgressListView';
import { usePayoutDetails } from '../../../models/usePayoutDetails';
import MoneyJarPayoutView from '../../../components/client/MoneyJarPayoutView';

const ClientPayoutScreen = ({
  locStrings,
  isAdmin,
}) => {
  const { clientId, payoutId } = useParams();
  const [payout] = usePayoutDetails(clientId, payoutId);
  const { displayName, status, provider } = payout || {};
  const [retrying, setRetrying] = useState(false);

  const onClick = async () => {
    const payoutModel = new StrikePayoutModel();
    await payoutModel.startConnectingProviderIfNeeded(payout);
  };

  const onRetrySetup = async () => {
    setRetrying(true);
    try {
      const payoutModel = new StrikePayoutModel();
      const result = await payoutModel.retryPayoutSetup(payout);
      if (result.success) {
        message.success('Retrying payout setup...');
      } else {
        message.warning(result.message || 'Unable to retry');
      }
    } catch (error) {
      message.error('Failed to retry setup');
      console.error(error);
    } finally {
      setRetrying(false);
    }
  };

  return <>
      {
        <PageHeader
          ghost={false}
          title={displayName || 'Payout Detail'}
          onBack={(() => window.history.back())}
        />
      } 
      <Space direction='vertical' style={{ width: '100%', padding: '0 16px' }}>

      { payout &&
        <MoneyJarPayoutView 
          clientId={clientId}
          payoutId={payoutId}
          payout={payout}
          onClick={onClick}
        />
      }

      { payout && provider === 'stripeus' && status === 'ready' && payout.actionRequiredMessage && (
        <Alert
          type="info"
          showIcon
          message="Bank Account Status"
          description={payout.actionRequiredMessage}
          style={{ marginBottom: 16 }}
        />
      )}

      { payout && provider === 'stripeus' && status === 'retry' && (
        <Alert
          type="warning"
          showIcon
          message="Payout Setup Requires Action"
          description={
            payout.actionRequiredMessage ||
            payout.lastErrorMessage || 
            'Your bank account setup encountered an issue. Click below to retry the setup process.'
          }
          action={
            <Button 
              type="primary" 
              loading={retrying}
              onClick={onRetrySetup}
            >
              Retry Setup
            </Button>
          }
          style={{ marginBottom: 16 }}
        />
      )}

      { isAdmin && payout && (
        <Card 
          title={<><Tag color="purple">Admin Only</Tag> Progress History</>}
          style={{ width: '100%' }}
        >
          <PayoutProgressListView 
            clientId={clientId}
            payoutId={payoutId}
            isAdmin={isAdmin}
          />
        </Card>
      )}
      
      { !payout && <CenteredSpinner /> }
      </Space>
    </>

};


export default ClientPayoutScreen;

